var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-small is-success",class:{
    'is-loading': _vm.isSubmitting,
    'is-success': _vm.activated,
    'is-danger': !_vm.activated
  },attrs:{"type":"button"},on:{"click":_vm.toggle}},[(_vm.activated)?[_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.$t('global.actions.deactivate')))]),_vm._v(" "),_c('span',[_vm._v("Aktiveret")])]:[_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.$t('global.actions.activate')))]),_vm._v(" "),_c('span',[_vm._v("Deaktiveret")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6b919dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/taskflex/administration/components/UserActivationToggleButton.vue
// module id = 8Ql7
// module chunks = 1